import { createFileRoute, redirect } from '@tanstack/react-router'
import { resolveSession } from '../features/auth/session'
import { SignInScreen } from '../features/auth/sign-in'
import { safeReturnTo } from '../lib/safeUrl'

interface SignInSearch {
  return_to?: string
  error?: string
}

/** Owned by web-shell (features/auth). The API's OAuth callback redirects here with `?error=` on failure. */
export const Route = createFileRoute('/signin')({
  validateSearch: (s: Record<string, unknown>): SignInSearch => ({
    return_to: typeof s.return_to === 'string' ? s.return_to : undefined,
    error: typeof s.error === 'string' ? s.error.slice(0, 64) : undefined,
  }),
  beforeLoad: async ({ context, search }) => {
    // Already signed in: go where the user was heading (same-origin paths only).
    if (search.error) return
    const session = await resolveSession(context.queryClient)
    if (session.kind === 'signed_in') throw redirect({ href: safeReturnTo(search.return_to) })
  },
  component: SignInRoute,
})

function SignInRoute() {
  const search = Route.useSearch()
  return <SignInScreen returnTo={safeReturnTo(search.return_to)} error={search.error} />
}
